export function keepNonEmptyValues(obj) {
  const result = Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => {
      if (Array.isArray(value)) return value.length > 0
      return value !== '' && value !== null && value !== undefined
    })
  )

  return Object.keys(result).length > 0 ? result : false
}
